var map = {
	"./DataHome": 67,
	"./DataHome.js": 67,
	"./Images/about-bg.jpg": 194,
	"./Images/appetizer-bg.jpg": 195,
	"./Images/appetizer-bg.png": 196,
	"./Images/appetizer.png": 197,
	"./Images/composto-bg.png": 198,
	"./Images/composto.png": 199,
	"./Images/contacts-bg.jpg": 200,
	"./Images/distribution-bg.jpg": 201,
	"./Images/home.jpg": 202,
	"./Images/jam-bg.png": 203,
	"./Images/jam.png": 204,
	"./Images/main-mobile.jpeg": 205,
	"./Images/main-video.mp4": 102,
	"./Images/narsharab-bg.png": 206,
	"./Images/narsharab.png": 207,
	"./Images/pasta-bg.png": 208,
	"./Images/pasta.png": 209,
	"./Images/pickle-bg.png": 210,
	"./Images/pickle.png": 211,
	"./Images/souse-bg.png": 212,
	"./Images/souse.png": 213,
	"./Images/tomatos.png": 214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 103;